import { withPrefix } from 'gatsby'

const ASSETS_BASE_URL = withPrefix('/phaser/assets/img')

export const PRODUCTS_ELEMENTS = {
  i_ambos_1: ASSETS_BASE_URL + '/game_utero/ambos/JABON-1.png',
  i_ambos_2: ASSETS_BASE_URL + '/game_utero/ambos/JABON-2.png',
  i_ambos_3: ASSETS_BASE_URL + '/game_utero/ambos/PANNITO-1.png',
  i_ambos_4: ASSETS_BASE_URL + '/game_utero/ambos/PANNITO-2.png',
  i_ambos_5: ASSETS_BASE_URL + '/game_utero/ambos/PANNITO-3.png',

  // i_periodo_1: ASSETS_BASE_URL + '/game_utero/periodo/TAMPON-1.png',
  i_periodo_2: ASSETS_BASE_URL + '/game_utero/periodo/TAMPON-2.png',
  i_periodo_3: ASSETS_BASE_URL + '/game_utero/periodo/TOALLA-1.png',
  i_periodo_4: ASSETS_BASE_URL + '/game_utero/periodo/TOALLA-2.png',
  i_periodo_5: ASSETS_BASE_URL + '/game_utero/periodo/TOALLA-3.png',

  i_fuera_periodo_1: ASSETS_BASE_URL + '/game_utero/fuera_periodo/DIAROS-1.png',
  i_fuera_periodo_2: ASSETS_BASE_URL + '/game_utero/fuera_periodo/DIAROS-2.png',
  i_fuera_periodo_3: ASSETS_BASE_URL + '/game_utero/fuera_periodo/DIAROS-3.png',
  i_fuera_periodo_4: ASSETS_BASE_URL + '/game_utero/fuera_periodo/DIAROS-4.png',
  i_fuera_periodo_5: ASSETS_BASE_URL + '/game_utero/fuera_periodo/DIAROS-5.png',

  bonus: ASSETS_BASE_URL + '/bonus_track.png',



}

export const ENVIRONMENT_ELEMENTS_UTERO = {
  u_clock: ASSETS_BASE_URL + '/game_utero/clock.svg',
  u_star: ASSETS_BASE_URL + '/game_utero/star.svg',
  moon: ASSETS_BASE_URL + '/game_utero/planeta_azul.png',
  moonShadown: ASSETS_BASE_URL + '/game_utero/sombras_planeta.png',
  plusPoints: ASSETS_BASE_URL + '/add_points.png',
  minusPoints: ASSETS_BASE_URL + '/remove_points.png',
  bonusPoints: ASSETS_BASE_URL + '/bonus-track_point.png',
  play: ASSETS_BASE_URL + '/play.svg',

  periodo_desk: ASSETS_BASE_URL + '/game_utero/categorias/periodo-desk.png',
  fuera_periodo_desk: ASSETS_BASE_URL + '/game_utero/categorias/fuera-periodo-desk.png',
  ambos_desk: ASSETS_BASE_URL + '/game_utero/categorias/ambos-desk.png',

  periodo_mob: ASSETS_BASE_URL + '/game_utero/categorias/periodo-mob.png',
  fuera_periodo_mob: ASSETS_BASE_URL + '/game_utero/categorias/fuera-periodo-mob.png',
  ambos_mob: ASSETS_BASE_URL + '/game_utero/categorias/ambos-mob.png',

}

export const SINTOMAS_ELEMENTS = {
  sintoma_1: ASSETS_BASE_URL + '/game_pubertad/sintomas/sintoma_1.png',
  sintoma_2: ASSETS_BASE_URL + '/game_pubertad/sintomas/sintoma_2.png',
  sintoma_3: ASSETS_BASE_URL + '/game_pubertad/sintomas/sintoma_3.png',
  sintoma_4: ASSETS_BASE_URL + '/game_pubertad/sintomas/sintoma_4.png',
  sintoma_5: ASSETS_BASE_URL + '/game_pubertad/sintomas/sintoma_5.png',
  sintoma_6: ASSETS_BASE_URL + '/game_pubertad/sintomas/sintoma_6.png',
  sintoma_7: ASSETS_BASE_URL + '/game_pubertad/sintomas/sintoma_7.png',
  sintoma_8: ASSETS_BASE_URL + '/game_pubertad/sintomas/sintoma_8.png',
  sintoma_9: ASSETS_BASE_URL + '/game_pubertad/sintomas/sintoma_9.png',
  bonus: ASSETS_BASE_URL + '/bonus_track.png',

}
export const SPRITE_ASSETS = {
  personajeSprite: ASSETS_BASE_URL + '/game_pubertad/personaje_sprite.png',
}

export const ENVIRONMENT_ELEMENTS_PUBERTAD = {
  m_clock: ASSETS_BASE_URL + '/game_pubertad/clock.svg',
  m_star: ASSETS_BASE_URL + '/game_pubertad/star.svg',
  play: ASSETS_BASE_URL + '/play.svg',
  lifeIcon: ASSETS_BASE_URL + '/game_pubertad/life.svg',
  lifeIconDisabled: ASSETS_BASE_URL + '/game_pubertad/life--disabled.svg',
  m_personaje: ASSETS_BASE_URL + '/game_pubertad/personaje.svg',
  planetaCircular: ASSETS_BASE_URL + '/game_pubertad/planeta-circular.png',
  btnArrow: ASSETS_BASE_URL + '/btn_arrow.svg',
  bonusPoints: ASSETS_BASE_URL + '/bonus-track_point.png',

}

export const GOUT_ELEMENTS = {
  gout_1: ASSETS_BASE_URL + '/game_flujo/gota-1.png',
  gout_3: ASSETS_BASE_URL + '/game_flujo/gota-3.png',
  gout_4: ASSETS_BASE_URL + '/game_flujo/gota-4.png',
  gout_5: ASSETS_BASE_URL + '/game_flujo/gota-5.png',
  gout_6: ASSETS_BASE_URL + '/game_flujo/gota-6.png',
  gout_7: ASSETS_BASE_URL + '/game_flujo/gota-7.png',
  gout_8: ASSETS_BASE_URL + '/game_flujo/gota-8.png',
  gout_9: ASSETS_BASE_URL + '/game_flujo/gota-9.png',
  gout_10: ASSETS_BASE_URL + '/game_flujo/gota-10.png',
  gout_11: ASSETS_BASE_URL + '/game_flujo/gota-11.png',
  bonus: ASSETS_BASE_URL + '/bonus_track.png',

}

export const ENVIRONMENT_ELEMENTS_FLUJO = {
  f_clock: ASSETS_BASE_URL + '/game_flujo/clock.svg',
  f_star: ASSETS_BASE_URL + '/game_flujo/star.svg',
  play: ASSETS_BASE_URL + '/play.svg',
  f_personaje: ASSETS_BASE_URL + '/game_flujo/personaje.png',
  plusPoints: ASSETS_BASE_URL + '/add_points.png',
  minusPoints: ASSETS_BASE_URL + '/remove_points.png',
  bonusPoints: ASSETS_BASE_URL + '/bonus-track_point.png',
  btnArrow: ASSETS_BASE_URL + '/btn_arrow.svg',
  nube_base_game: ASSETS_BASE_URL + '/game_flujo/nube.png',
}
